/*
 * Created on Tue Nov 28 2017
 *
 * Copyright (c) 2017 Sébastien Hecart
 */
import S00GAZ from './Section/S00_GAZ/S00_GAZ_w.svg'
import S01ECS from './Section/S01_ECS/S01_ECS_w.svg'
import S02BILANFINECO from './Section/S02BILANFINECO/S02BILANFINECO_w.svg'
import S03AIR from './Section/S03AIR/S03AIR_w.svg'
import S04CHAUDIERE from './Section/S04_CHAUDIERE/S04_CHAUDIERE_w.svg'
import S06DECHYDRO from './Section/S06_DECHYDRO/S06_DECHYDRO_w.svg'
import S07RADIATEUR from './Section/S07_RADIATEUR/S07_RADIATEUR_w.svg'
import S08VASEEXPANSION from './Section/S08_VASEEXPANSION/S08_VASEEXPANSION_w.svg'
import S09CIRCULATEUR from './Section/S09_CIRCULATEUR/S09_CIRCULATEUR_w.svg'
import S10TUYAUTERIE from './Section/S10_TUYAUTERIE/S10_TUYAUTERIE_w.svg'
import S11PERTECHARGE from './Section/S11_PERTECHARGE/S11_PERTECHARGE_w.svg'
import S12VOLINSTCHAUF from './Section/S12_VOLINSTCHAUF/S12_VOLINSTCHAUF_w.svg'
import S13CHAUFFERIE from './Section/S13_CHAUFFERIE/S13_CHAUFFERIE_w.svg'
import S14VANNE from './Section/S14_VANNE/S14_VANNE_w.svg'
import S15BOIS from './Section/S15_BOIS/S15_BOIS_w.svg'
import S16TRAITEMENTDEAU from './Section/S16_TRAITEMENTDEAU/S16_TRAITEMENTDEAU_w.svg'
import S17COGENERATION from './Section/S17COGENERATION/S17COGENERATION_w.svg'
import S18VENTILATION from './Section/S18VENTILATION/S18VENTILATION_w.svg'
import S21RENDEMENT from './Section/S21RENDEMENT/S21RENDEMENT_w.svg'

const images: { [x: string]: string } = {
  S00GAZ,
  S01ECS,
  S02BILANFINECO,
  S03AIR,
  S04CHAUDIERE,
  S06DECHYDRO,
  S07RADIATEUR,
  S08VASEEXPANSION,
  S09CIRCULATEUR,
  S10TUYAUTERIE,
  S11PERTECHARGE,
  S12VOLINSTCHAUF,
  S13CHAUFFERIE,
  S14VANNE,
  S15BOIS,
  S16TRAITEMENTDEAU,
  S17COGENERATION,
  S18VENTILATION,
  S21RENDEMENT
}

export default images
